import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { RelationshipType, RelationshipDataItem } from './models/partner';
import { Privilege, PrivilegeGroup } from './models';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var PartnerService = /** @class */ (function () {
    function PartnerService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.uniquePrivileges = [];
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    PartnerService.prototype.getSourcePartners = function (SearchText, PartnerType) {
        var api = _GlobalNS.api.partner.sourceData;
        var params = new HttpParams().set('RelationshipTypeId', PartnerType.RelationshipTypeId.toString()).set('SearchText', SearchText);
        return this._http.get("" + api, { params: params });
    };
    PartnerService.prototype.findByTextandRelationshipType = function (txt, relationshipTypeId) {
        var api = _GlobalNS.api.relationship.relationshipDataItem;
        var params = new HttpParams().set('RelationshipTypeId', relationshipTypeId.toString()).set('SearchText', txt);
        return this._http.get("" + api, { params: params });
    };
    PartnerService.prototype.assetGroupSearchObservable = function (sSubject, relationshipType) {
        var _this = this;
        return sSubject.pipe(debounceTime(400), distinctUntilChanged(), switchMap(function (value) {
            return _this.findByTextandRelationshipType(value, relationshipType.RelationshipTypeId);
        }));
    };
    PartnerService.prototype.create = function (PartnerCreateInstance) {
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        var api = _GlobalNS.api.partner.createPartner;
        return this._http.post(api + "&eqrf=" + eqrf, PartnerCreateInstance, this.httpOptions);
    };
    PartnerService.prototype.update = function (PartnerUpdateInstance) {
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        var api = _GlobalNS.api.partner.updatePartnership;
        return this._http.post(api + "&eqrf=" + eqrf, PartnerUpdateInstance, this.httpOptions);
    };
    PartnerService.prototype.deactivate = function (RelationID, personid) {
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        var api = _GlobalNS.api.partner.deactivatePartner;
        var params = { 'RelationshipID': RelationID, 'PersonId': personid };
        return this._http.post(api + "&eqrf=" + eqrf, params, this.httpOptions);
    };
    // reusable function to get privileges based on privileges and group privileges.
    PartnerService.prototype.getUniquePrivileges = function (privilegeGroups, privileges) {
        var _this = this;
        this.uniquePrivileges = [];
        if (privileges !== undefined && privileges.length) {
            privileges.map(function (item) {
                _this.uniquePrivileges.push(item);
            });
        }
        if (privilegeGroups !== undefined && privilegeGroups.length) {
            privilegeGroups.map(function (privilegeGroup) {
                privilegeGroup.Privileges.map(function (privilege) {
                    if (!_this.uniquePrivileges.some(function (item) { return item.PrivilegeId === privilege.PrivilegeId; })) {
                        _this.uniquePrivileges.push(privilege);
                    }
                });
            });
        }
        return this.uniquePrivileges;
    };
    PartnerService.ngInjectableDef = i0.defineInjectable({ factory: function PartnerService_Factory() { return new PartnerService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: PartnerService, providedIn: "root" });
    return PartnerService;
}());
export { PartnerService };
